import axios from "axios";

const apiAchados = axios.create({
    baseURL: "https://sheetdb.io/api/v1/zc1vygqcnbt0g"
});

const lerAchados = async () => {
    const itens = [];
    
    try {
        const resposta = new Promise( async (resolve, reject) => {
            const dados = await apiAchados.get();
            const data = dados.data;
            data.map( async (dado) => {
                await itens.push(dado)
            })
            await resolve(itens);
        });
        return resposta;
    } catch (error) {
        console.error("Ocorreu um erro na requisição GET:", error.message);
    }
};

export { lerAchados };